import React, { useEffect } from "react";

const SORO_SCRIPT_SRC = "https://app.trysoro.com/api/embed/f8941000-d8a3-4dea-81c4-dc5646cfa074";

const SoroBlogWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = SORO_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="bg-parchment py-20 sm:py-28" data-testid="soro-blog-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
          <span className="h-px w-10 bg-gold/60" />
          Insights
        </div>
        <h2 className="font-display text-3xl sm:text-4xl text-ink tracking-tight leading-[1.06] mt-6">
          Latest Insights
        </h2>
        <div id="soro-blog" className="mt-10" data-testid="soro-blog-widget"></div>
      </div>
    </section>
  );
};

export default SoroBlogWidget;
